import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// Handles Emergent OAuth redirect: reads #session_id=..., exchanges it, redirects home.
const AuthCallback = () => {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const user = await exchangeSession(sessionId);
        toast.success(`Welcome, ${user.name?.split(" ")[0] || "there"}!`);
      } catch {
        toast.error("Google login failed, please try again");
      } finally {
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f6faf7]">
      <Loader2 size={40} className="text-[#12a150] animate-spin mb-3" />
      <div className="text-[14px] font-semibold text-gray-700">Signing you in...</div>
      <div className="text-[12px] text-gray-400 mt-1">Please wait a moment</div>
    </div>
  );
};

export default AuthCallback;
